"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AskSpecSchema = exports.ASK_INPUT_TYPES = exports.PROVIDER_IDS = void 0;
const zod_1 = require("zod");
/**
 * A PROVIDER is a pure mapper from a domain object the platform already holds
 * to that provider's string values. Providers do NO I/O — they are imported by
 * Lambdas and by both UIs, so they must stay framework- and network-free.
 * Fetching stays in the services; the service composes, it never names a field.
 */
exports.PROVIDER_IDS = [
    'company', 'customer', 'signer', 'guarantor',
    'equipment', 'device', 'package', 'finance', 'deal', 'agreement',
    'vendor', 'employee', 'partner',
];
exports.ASK_INPUT_TYPES = [
    'text', 'email', 'phone', 'address', 'ein', 'currency', 'date',
];
/**
 * `required` is the LITERAL true, not a boolean. An optional ask would
 * reintroduce exactly the blank this engine exists to prevent.
 */
exports.AskSpecSchema = zod_1.z.object({
    askOf: zod_1.z.enum(['operator', 'customer', 'signer']),
    question: zod_1.z.string().trim().min(1),
    help: zod_1.z.string().trim().min(1).optional(),
    inputType: zod_1.z.enum(exports.ASK_INPUT_TYPES),
    required: zod_1.z.literal(true),
});
//# sourceMappingURL=types.js.map